import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/embr/assets/images/embr.png'
import _imports_1 from '@/embr/assets/images/velas-icon.svg'
import _imports_2 from '@/embr/assets/images/twitter-icon.png'
import _imports_3 from '@/embr/assets/images/medium-icon.png'
import _imports_4 from '@/embr/assets/images/discord-icon.png'
import _imports_5 from '@/embr/assets/images/gitbook-logo.png'
import _imports_6 from '@/embr/assets/images/github-logo.png'


const _hoisted_1 = {
  class: "pb-16 relative custom-router-view",
  style: {}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative mt-32" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 flex justify-left pb-6 ml-8" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"display":"flex"} }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        width: "18",
        height: "18",
        style: {"margin-right":"10px"}
      }),
      /*#__PURE__*/_createTextVNode("Wavelength")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 right-1 flex justify-end pb-6 mr-8" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "flex items-center" }, [
      /*#__PURE__*/_createTextVNode("Powered by Velas "),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        width: "24",
        height: "24",
        class: "ml-2"
      })
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative wave-footer-line ml-8 mr-8" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative mt-16" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 flex justify-left pb-6 ml-8" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300"} }, "Copyright ⓒ 2022 Wavelength. All rights reserved")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex absolute bottom-0 left-1/2 transform -translate-x-1/2 flex justify-center pb-6 ml-8" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://twitter.com/Wavelength_DAO",
        class: "mr-12",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://medium.com/@Wavelength_DAO",
        class: "mr-12",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://discord.gg/YE44J8fxbh",
        class: "mr-12",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_4,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://docs.wavelength.exchange",
        class: "mr-12",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/wavelength-velas",
        class: "mr-12",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_6,
          width: "25",
          class: "mx-auto"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 right-1 flex justify-end pb-6 mr-8" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://pdfhost.io/v/6nXpANnrp_Wavelength_Terms_of_Service",
      target: "_blank",
      style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
    }, "Terms of Service"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://pdfhost.io/v/Gbwje17oo_Wavelength_Risk_Disclosure_Statement",
      target: "_blank",
      style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
    }, "Risk Disclosure Statement"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://pdfhost.io/v/AQAwyYO5._Wavelength_Legal_Notice",
      target: "_blank",
      style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
    }, "Legal Notice"),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://pdfhost.io/v/OGp3wZXDi_Wavelength_Privacy_Notice",
      target: "_blank",
      style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
    }, "Privacy Notice")
  ])
], -1)

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppNav from '@/embr/components/navs/AppNav.vue';
import AppFooterNav from '@/components/navs/AppFooterNav/AppFooterNav.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import AppHeaderBg from '@/embr/components/backgrounds/AppHeaderBg.vue';
import AppHero from '@/embr/components/heroes/AppHero.vue';
import GlobalStats from '@/embr/components/stats/GlobalStats.vue';
import DarkModeToggle from '@/components/btns/DarkModeToggle.vue';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const route = useRoute();
const { upToXLargeBreakpoint } = useBreakpoints();

/**
 * COMPUTED
 */
const isFarmsPage = computed(() => route.path === '/farm');
const isPortfolioPage = computed(() => route.path === '/my-portfolio');
const isInvestPage = computed(() => {
  return route.path === '/pools';
});
const isTradePage = computed(() => {
  return route.path === '/trade';
});
const showGlobalStats = computed(() => {
  return isInvestPage.value || isFarmsPage.value || isTradePage.value;
});
const isHomePage = computed(() => route.path === '/');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppNav),
    _createVNode(AppHeaderBg),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, {
        key: _ctx.$route.path
      })
    ]),
    (_unref(upToXLargeBreakpoint))
      ? (_openBlock(), _createBlock(AppFooterNav, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})